import React from 'react';

import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css';

/**
 * Renders a single teaser card.
 *
 * @example
 * import {ArticleCard} from '@ta-interaktiv/react-article-teasers'
 * function MyComponent (props) {
 *   return (
 *     <ArticleCard
 *       url='https://www.tagesanzeiger.ch'
 *       imageSrc='https://interaktiv.tagesanzeiger.ch/teaser.jpg'
 *       title='Schlagzeile'
 *       lead='<p>Das müssen Sie gelesen haben.</p>'
 *       authors='Interaktiv-Team'
 *     />
 *   )
 * }
 *
 *
 * @param {object} props
 * @param {string} props.url The (article) URL to link to.
 * @param {string} props.imageSrc The source URL of the teaser image.
 * @param {string} props.title The title of the article.
 * @param {string} [props.authors] A string with the author information
 * @param {string} props.lead The lead of the article
 * @param {string} [props.className] Any additional class names the card
 * should receive
 * @param {Node} [props.commentary] A comment for this teaser.
 * Displayed on the bottom of the teaser in a blue message box.
 * @param {string} [props.commentaryIcon] An optional icon to go with the
 * commentary
 */
export function ArticleCard(_ref) {
  var url = _ref.url,
      openInNewWindow = _ref.openInNewWindow,
      imageSrc = _ref.imageSrc,
      title = _ref.title,
      authors = _ref.authors,
      lead = _ref.lead,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      commentary = _ref.commentary,
      commentaryIcon = _ref.commentaryIcon;

  return React.createElement(
    'a',
    {
      href: url,
      target: openInNewWindow ? '_blank' : '_top',
      onClick: function onClick() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Interactions',
          event_action: 'click',
          event_label: 'articleCard:' + url
        });
      },
      className: 'ui article-teaser card ' + className
    },
    React.createElement(
      'div',
      { className: 'image' },
      React.createElement('img', { src: imageSrc })
    ),
    React.createElement(
      'div',
      { className: 'content' },
      React.createElement(
        'div',
        { className: 'header' },
        title
      ),
      React.createElement('div', {
        className: 'description',
        dangerouslySetInnerHTML: { __html: lead }
      }),
      React.createElement(
        'div',
        null,
        'Mehr\u2009\u2026'
      )
    ),
    authors && authors !== '' && React.createElement(
      'div',
      { className: 'extra content' },
      authors
    ),
    commentary && commentary !== '' && React.createElement(
      'div',
      { className: 'ui small info icon message commentary' },
      commentaryIcon && React.createElement('i', { className: 'small ' + commentaryIcon + ' icon' }),
      React.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: commentary } })
    )
  );
}

export default ArticleCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-article-teasers/es/articleCard.js
// module id = null
// module chunks = 